module.exports = __webpack_public_path__ + "img/img15.403902d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img15.png
// module id = 255
// module chunks = 0